import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_flexcol" }
const _hoisted_2 = { class: "_mt-0 _mb-2" }
const _hoisted_3 = { class: "_mt-0 _mb-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_text_field = _resolveComponent("text-field")
  const _component_localize = _resolveComponent("localize")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_external_login_actions = _resolveComponent("external-login-actions")
  const _component_login_form = _resolveComponent("login-form")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoginFormVisible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.Account.FollowProjectWithAnAccountModalDescription), 1 /* TEXT */),
          _createVNode(_component_base_button, {
            onClick: $options.onLoginAction,
            "data-qa": "modal-button:ContinueWithAnAccount"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Account.FollowProjectWithAnAccountModalActionButton), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "_bb-2 _bc--soft _my-3" }, null, -1 /* CACHED */)),
          _createVNode(_component_base_heading, {
            tag: "h2",
            class: "_mb-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Account.FollowProjectAsGuestModalHeader), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.Resources.Account.FollowProjectAsGuestModalDescription), 1 /* TEXT */),
          _createVNode(_component_text_field, {
            modelValue: _ctx.model.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model.email) = $event)),
            "display-name": "User email",
            name: "model.email",
            "data-qa": "modal-field:Email"
          }, null, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_checkbox_field, {
            modelValue: _ctx.model.termsAccepted,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.model.termsAccepted) = $event)),
            name: "model.termsAccepted",
            "display-name": _ctx.Resources.Account.CompleteAccountTermsOfServiceFieldName,
            class: "_my-3",
            condensed: true,
            "data-qa": "modal-checkbox:TermsOfService"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createVNode(_component_localize, {
                  resource: _ctx.Resources.Account.CompleteAccountTermsConsentLabel
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      "format-key": "0",
                      class: "gfu-link gfu-link--accent",
                      href: _ctx.termsOfServiceUrl,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, _toDisplayString(_ctx.Resources.Account.CompleteAccountTosLink), 9 /* TEXT, PROPS */, _hoisted_4),
                    _createElementVNode("a", {
                      "format-key": "1",
                      class: "gfu-link gfu-link--accent",
                      href: _ctx.privacyPolicyUrl,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, _toDisplayString(_ctx.Resources.Account.CompleteAccountPrivacyPolicyLink), 9 /* TEXT, PROPS */, _hoisted_5)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "display-name"]),
          _createVNode(_component_base_button, {
            display: "block",
            onClick: $options.submit,
            "data-qa": "modal-button:FollowAsGuest"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Account.FollowProjectAsGuestModalActionButton), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_external_login_actions, {
            "return-url": $props.returnUrl,
            class: "_mb-3",
            onSuccess: $options.onSuccess
          }, null, 8 /* PROPS */, ["return-url", "onSuccess"]),
          _createVNode(_component_login_form, {
            "return-url": $props.returnUrl,
            onSuccess: $options.onSuccess
          }, null, 8 /* PROPS */, ["return-url", "onSuccess"])
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}